import Button from "../../UI/Button";

export default function EarTrainerAudioStatus({ audio, onRetry, onResume }) {
  if (audio.status === "ready") return null;
  const failed = audio.status === "error" || audio.status === "blocked";
  return <tr><td colSpan={2}>
    <div role={failed ? "alert" : "status"} aria-label="Ear Trainer audio">
      {audio.message}
      {audio.status === "error" && <Button onClick={onRetry}>Retry audio</Button>}
      {audio.status === "blocked" && <Button onClick={onResume}>Resume audio</Button>}
    </div>
  </td></tr>;
}
